import { useResetAtom } from 'jotai/react/utils';

import { entityAtom } from '../entityAtom';

const useStoreManager = () => {
  const resetEntity = useResetAtom(entityAtom);

  const onResetSession = () => {
    resetEntity();
  };

  return {
    onResetSession,
  };
};

export default useStoreManager;
